import React, { useState, useEffect} from "react";
import { Link } from "react-router-dom";
import AOS from 'aos';

// Images
import registration_banner from '../images/banner_images/laptop/registration.png'
import mobregistration_banner from '../images/banner_images/mobile/mobile_registration.png'
import consultation from '../images/registration/consultation.png'
import drafting from '../images/registration/drafting.png'
import registration from '../images/registration/registration.png'
import sale_deed from '../images/registration/sale_deed.png'
import lease_rent from '../images/registration/lease_rent.png'
import property_gift from '../images/registration/property_gift.png'
import property_partition from '../images/registration/property_partition.png'
import property_release from '../images/registration/property_release.png'
import sale_agreement from '../images/registration/sale_agreement.png'
import property_settlement from '../images/registration/property_settlement.png'
import attorney from '../images/registration/attorney.png'
import will_deed from '../images/registration/will_deed.png'
import property_exchange from '../images/registration/property_exchange.png'
import google_logo from '../images/liaison/Google-Review-Logo 1.png'
import calander from "../images/registration/calander_icon.png"
import registration_complete from '../images/registration/approval_icon.png'
import advocate from '../images/registration/advocate_icon.png'
import clients from '../images/registration/group_icon.png'

// Components
import Banner from '../Components/Banner'
import Button from "../Components/Button";
import Whyus from '../Card-Components/Whyus'
import Testimonial_slider from '../Components/testimonial_slider'
import Chatwithus from "../Components/chatwithus";
import FormModal from "../Components/FormModal";

function Registration() {

     useEffect(()=>{
            AOS.init({duration:1000});
        }, [])

     // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    function toggle () {
        setModalToggle(!modalToggle);
    }
    // -------------------

    const registration_Services = [ 
        {
            icon: sale_deed,
            heading: "Sale Deed",
            content: "Transfer ownership of your property.",
            link: "#"
        },
        {
            icon: lease_rent,
            heading: "Lease and Rent",
            content: "Manage the possession of a property for a set period and payment. ",
            link: "#"
        },
        {
            icon: property_gift,
            heading: "Property Gift",
            content: "Pass the property ownership from donor to done without any payment. ",
            link: "#"
        },
        {
            icon: property_partition,
            heading: "Property Partition",
            content: "Divide the jointly-owned property into sepearte ownership",
            link: "#"
        },
        {
            icon: property_release,
            heading: "Property Release",
            content: "Transfer, release or relinquish property ownership rights.",
            link: "#"
        },
        {
            icon: sale_agreement,
            heading: "Sale Agreement",
            content: "Outline the terms for future transfer of property",
            link: "#"
        },
        {
            icon: property_settlement,
            heading: "Property Settlement",
            content: "Divide the property after your legal separation.",
            link: "#"
        },
        {
            icon: attorney,
            heading: "Power of Attorney",
            content: "Appoint authority to a person to act on behalf of another person.",
            link: "#"
        },
        {
            icon: will_deed,
            heading: "Will Deed",
            content: "Outline how to pass the properties after death",
            link: "#"
        },
        {
            icon: property_exchange,
            heading: "Property Exchange",
            content: "Swap the ownership between properties.",
            link: "#"
        },
    ]

        const milestoneCard =[
        {
            icon:calander,
            milestone_number:"15+",
            milestone_content:"Years Experience",
        },
        {   
            icon:registration_complete,
            milestone_number:"1000+ ",
            milestone_content:"Registrations completed",
        },
        {
            icon:advocate,
            milestone_number:"5 Million",
            milestone_content:"Advocates",
        },
        {
            icon:clients,
            milestone_number:"500+",
            milestone_content:"Clients",
        },
    ]
    

    return (
        <>
            <Banner
                img={registration_banner}
                mimg={mobregistration_banner}
                alt={"registration_banner"}
                heading={"Secure your property ownership and future"}
                subheading={"Registration made easy"}
                textposition={"w-[85%] bottom-8 left-8 right-8 lg:w-[675px] lg:bottom-[100px] lg:left-[100px]"}
                renderButton={() => (
                    <Button name={'Get Registration'} design={"filled"} action={"modal-open"} modalfunction={toggle} />
                )}
            />

            {/* Description */}

            <div className='max-w-[960px] mx-auto my-[40px] lg:my-[100px] px-4'>
                <h1 className='heading' data-aos="fade-up">Drafting & Registration</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[35px]' data-aos="fade-up" data-aos-duration="800"/>
                <p className="service-description max-w-[870px] mx-auto" data-aos="fade-up" data-aos-duration="1100">Whether buying or leasing a property for industry or a warehouse, we help you with location anchoring, site-selection, build-to-suit opportunities, and leasing services. We're dedicated to guiding you through industrial property nuances, ensuring strategic decisions aligned with your business goals.</p>
            </div>

            {/* Process */}

            <div className="max-w-[1200px] mx-auto py-[30px] space-y-[60px] md:space-y-[100px]">

                {/* Consultation */}
                <div className="flex flex-col-reverse lg:flex-row justify-between gap-6 px-4" data-aos="fade-up">

                    <div className="max-w-[485px] mx-auto my-auto xl:mx-0">
                        <h1 className="font-noto text-[32px] font-bold">Consultation</h1>
                        <p className="font-alibaba text-[20px] text-font-grey leading-[28px] mt-[10px] mb-[40px]">Understand the critical terms in your deeds and their implications with our expert review and consultation.</p>

                        <Button
                            name={"Consult Now"}
                            design={"filled"}
                            action={"modal-open"}
                            modalfunction = {toggle}
                        />
                    </div>

                    <img className="w-[500px] xl:w-[610px] mx-auto lg:mx-0" src={consultation} alt="consultation" />

                </div>


                {/* Drafting */}
                <div className="flex flex-col lg:flex-row justify-between gap-6 px-4" data-aos="fade-up">

                    <img className="w-[500px] xl:w-[610px] mx-auto lg:mx-0" src={drafting} alt="Drafting"/>

                    <div className="max-w-[485px] mx-auto my-auto xl:mx-0">
                        <h1 className="font-noto text-[32px] font-bold">Drafting</h1>
                        <p className="font-alibaba text-[20px] text-font-grey leading-[28px] mt-[10px] mb-[40px]">Craft legally sound property sales deeds, purchase agreements, and other closing documents that safeguard your interests.</p>

                        <Button
                            name={"View All Services"}
                            design={"filled"}
                            action={"scroll"}
                            section_id={"services"}
                        />
                    </div>
                </div>

                {/* Registration */}
                <div className="flex flex-col-reverse lg:flex-row justify-between gap-6 px-4" data-aos="fade-up">

                    <div className="max-w-[485px] mx-auto my-auto xl:mx-0">
                        <h1 className="font-noto text-[32px] font-bold">Registration</h1>
                        <p className="font-alibaba text-[20px] text-font-grey leading-[28px] mt-[10px] mb-[40px]">Streamline your registration journey with our deep familiarity with regulations and sub-registrary processes.</p>

                        <Button
                            name={"View All Services"}
                            design={"filled"}
                            action={"scroll"}
                            section_id={"services"}
                        />
                    </div>

                    <img className="w-[500px] xl:w-[610px] mx-auto lg:mx-0" src={registration} alt="Registration" />

                </div>
            </div>

            {/* Registration Services  */}

            <div className='my-[40px] lg:my-[100px]' id="services">
                <h1 className='heading' data-aos="fade-up">Services</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>

                {/* Loop Service card */}

                <div className="max-w-[1200px] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:gap-y-12 xl:grid-cols-4 lg:gap-[22px] mt-[70px] px-3 ">
                    {
                        registration_Services.map((items) => {
                            return (
                                <Link to={items.link} >
                                    <div className="mx-auto bg-grey w-[280px] h-[273px] p-[25px]" data-aos="fade-up">
                                        <img src={items.icon} alt="icons" />
                                        <h1 className="font-noto text-[22px] font-bold leading-[36px] mt-[30px]">{items.heading}</h1>
                                        <p className="text-[16px] text-font-grey leading-[22px] mt-[10px]">{items.content}</p>
                                    </div>
                                </Link>

                            )
                        })
                    }
                </div>
            </div>

            <Whyus />

            {/* Milestones */}
            <section className="bg-[#363537] text-white font-alibaba px-4 py-[40px] sm:py-[90px]">

                <div className="max-w-[1120px] mx-auto px-2 sm:flex flex-wrap justify-between">
                    {
                        milestoneCard.map((items) => {
                            return (
                                <div className="w-[232px] mx-auto flex flex-col items-center text-center mt-20 sm:mt-6 lg:mt-0 md:mx-0">
                                    <img src={items.icon} alt="icons"  data-aos="fade-up"/>
                                    <h2 className="text-yellow text-[40px] font-semibold leading-[45px] max-w-[236px] mt-[45px]" data-aos="fade-up">{items.milestone_number}</h2>
                                    <hr className="w-full border-[0.50px] border-[#EECA01] my-[25px]"  data-aos="fade-up"/>
                                    <h3 className="max-w-[105px] text-[20px]" data-aos="fade-up">{items.milestone_content}</h3>
                                </div>

                            );
                        })}
                </div>

            </section>


            <Testimonial_slider />

            <a href='https://www.google.com/search?sca_esv=0cc3b5bc5eb43f9c&si=AMgyJEvkVjFQtirYNBhM3ZJIRTaSJ6PxY6y1_6WZHGInbzDnMQrBjsHIRqCxxwTbPxUbJ4RMTn-S7H5ZS_OlrXE3HjAzhGXUfdnaJrezLduvGnb69kqo76JZmUEA-jPkDJw4eW3a1_LH&q=Lands+and+Lands+Reviews&sa=X&ved=2ahUKEwin4ZCY1LmPAxU6R2cHHVIaIpUQ0bkNegQIJhAE&biw=1504&bih=860&dpr=2' target="_blank">
                <div className='flex-col justify-center text-center'>
                    <img className='w-[168px] mx-auto' src={google_logo} alt='Google_logo'  data-aos="fade-up"/>
                    <p className='text-[18px] text-[#575857] mt-[10px]' data-aos="fade-up">Check out our Google reviews page <span className='text-[#FF0000]'> here.</span></p>
                </div>
            </a>


            <Chatwithus />
            <FormModal modal={modalToggle} active={toggle} />

        </>
    );
}

export default Registration;